import BaseComponent from './base-component'
import Odometer from 'odometer'
import ElementTracker from '../element-tracker'

export default class OdometerComponent extends BaseComponent {
  constructor (layout, element, componentName, breakpoint, scrollPosition, windowHeight, index) {
    super(...arguments)
    this.layout = layout
    this.element = layout.element
    this.odometerAnimationItems = []
    this.rafWhenVisible = true
    this._elementTracker = new ElementTracker(null, {
      autoStart: true
    })
    this._initialize()
  }

  _initialize () {
    var elements = this.element.querySelectorAll('[data-odometer-animation]:not(.odometer)')
    for (var i = 0, l = elements.length; i < l; i++) {
      const element = elements[i]
      let data
      try {
        data = JSON.parse(element.dataset.odometerAnimation) || {}
      } catch (err) {
        data = {}
      }
      const value = parseFloat(data.value || element.innerHTML)
      const odometer = new Odometer({
        el: element,
        theme: 'minimal',
        value: data.start || 0,
        format: data.format || 'd',
        duration: data.duration || 2000
      })
      const trackedElement = this._elementTracker.addElement(element)
      if (trackedElement.inView) { // Already in view, no need to track
        odometer.update(value)
      } else {
        trackedElement.on('enterview', () => {
          odometer.update(value)
        })
      }
      this.odometerAnimationItems.push({
        value,
        odometer,
        trackedElement
      })
    }
  }

  _reInitialize () {
    this._destroyOdometerAnimations()
    this._initialize()
    this.setupEvents()
  }

  _destroyOdometerAnimations () {
    for (var i = 0, l = this.odometerAnimationItems.length; i < l; i++) {
      this.odometerAnimationItems[i].trackedElement.destroy()
      this.odometerAnimationItems[i] = null
    }
    this.odometerAnimationItems.length = 0
  }

  destroy () {
    this._destroyOdometerAnimations()
    this._elementTracker.destroy()
    super.destroy()
  }
}
